module.exports = __webpack_public_path__ + "media/images/flt-icon-alt@4x-ef2285147e1b551d95194df2baf1d18f.png";